import {
    GET_TASK_NOTIFICATION_SUCCESS,
    GET_TASK_NOTIFICATION_FAILURE,
    GET_SMS_NOTIFICATION_SUCCESS,
    GET_SMS_NOTIFICATION_FAILURE,
    GET_NOTIFICATION_COUNT_SUCCESS,
    GET_NOTIFICATION_COUNT_FAILURE,
} from "../actions/actionTypes";

const initialState = {
    unreadSmsAlerts: JSON.parse(localStorage.getItem("unreadSmsAlerts")) || [],
    countNotifications: Number(localStorage.getItem("countNotifications")) || 0,
    getTaskNotification: [],
    selectedTask: null,
    error: null,
};

const notificationPanelReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TASK_NOTIFICATION_SUCCESS:
        return {
            ...state, getTaskNotification: action.payload, error: null};
        case "SET_SELECTED_TASK":
        return { ...state, selectedTask: action.payload };

        case GET_SMS_NOTIFICATION_SUCCESS: {
            if (!Array.isArray(action.payload)) {
                return { ...state, error: "Invalid payload received for SMS notifications" };
            }
            const updatedSms = [...action.payload];
            localStorage.setItem("unreadSmsAlerts", JSON.stringify(updatedSms));
            return {
                ...state,
                unreadSmsAlerts: updatedSms,
                error: null
            };
        }

        case GET_NOTIFICATION_COUNT_SUCCESS: {
            const updatedCount = typeof action.payload === "number" ? action.payload : 0;
            localStorage.setItem("countNotifications", updatedCount.toString());
            return {
                ...state,
                countNotifications: updatedCount,
                error: null
            };
        }

        case GET_TASK_NOTIFICATION_FAILURE:
        case GET_SMS_NOTIFICATION_FAILURE:
        case GET_NOTIFICATION_COUNT_FAILURE:
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};

export default notificationPanelReducer;
